/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import { ReactNode, useState } from 'react';
import * as React from 'react';
import { Typography, TypographyProps } from 'palette/Typography';

import './styles/TextLink.scss';

interface TextLinkProps
    extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'color'>,
    Pick<TypographyProps, 'transform' | 'weight' | 'color' | 'underlineOffset'> {
    href: string;
    children: ReactNode;
    isNewTab?: boolean;
    isUnderlinedOnHover?: boolean;
}

function TextLink({
    children,
    isNewTab = false,
    rel,
    isUnderlinedOnHover = false,
    transform,
    weight,
    color,
    className,
    underlineOffset,
    onMouseEnter,
    onMouseLeave,
    ...anchorProps
}: TextLinkProps, ref: React.Ref<HTMLAnchorElement>) {
    const [isUnderlined, setIsUnderlined] = useState(!isUnderlinedOnHover);
    const classes = classNames('palette-text-link', className);

    const handleMouseEnter = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        onMouseEnter?.(event);
        setIsUnderlined(isUnderlinedOnHover);
    };

    const handleMouseLeave = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        onMouseLeave?.(event);
        setIsUnderlined(!isUnderlinedOnHover);
    };

    return (
        <a
            className={classes}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            {...isNewTab && {
                target: '_blank',
                rel: 'noopener',
            }}
            {...anchorProps}
            ref={ref}
        >
            <Typography
                color={color}
                transform={transform}
                underlineOffset={underlineOffset}
                weight={weight}
                {...(isUnderlined && { textDecoration: 'underline' })}
            >
                {children}
            </Typography>
        </a>
    );
}

export default React.forwardRef(TextLink);
